module.exports = __webpack_public_path__ + "img/bgc2.90d0ae5f.png";